(function (angular) {
    'use strict';

    angular.module('profiles')
        /**
         *
         */
        .controller('uploadModal', ['$scope', '$state', '$stateParams', '$uibModalInstance', 'profilesService', 'growlService', 'profileSchema', 'allowOtherProperties', 'countries', 'WizardHandler', function ($scope, $state, $stateParams, $uibModalInstance, profilesService, growlService, profileSchema, allowOtherProperties, countries, WizardHandler) {
            $scope.fileValid = false;
            $scope.custom = {};
            $scope.config = {
                optInSettings: {
                    optIn: false,
                    customOptIn: false
                },
            };
            $scope.newFile = {};
            $scope.phoneNumberCountryCodes = countries.map(function(item){
                return {
                    value: item.code,
                    label: "+" + item.callingCode + " " + item.name
                };
            });

            $scope.phoneNumberCountryCodes.unshift({
                value: "INTERNATIONAL",
                label: "International Format"
            });

            function clickBlocker(state){
                return state >= WizardHandler.wizard("importWizard").currentStepNumber();
            }

            $scope.allowOtherProperties = allowOtherProperties;
            var csvMime = ['text/comma-separated-values', 'text/csv', 'application/csv', 'application/excel', 'application/vnd.ms-excel', 'application/vnd.msexcel', 'text/anytext', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
            var types = ['csv', 'xlsx'];
            var fileType;
            var hasEmptyKey = false;
            
            var newFileWatch = $scope.$watch('newFile.data', function (newVal, oldVal) {
                if (newVal) {
                    fileType = newVal.name.split('.').pop();
                    if (csvMime.includes(newVal.type) && types.includes(fileType)) {
                        $scope.fileValid = true;
                        delete $scope.wrongFileError;
                    }
                    else {
                        $scope.fileValid = false;
                        $scope.wrongFileError = "Chosen file is not in the correct format. Please upload a csv or xlsx file and try again";
                    }
                }
            });

            $scope.next = function(){
                var wizardHandler = WizardHandler.wizard("importWizard");
                var stateNumber = wizardHandler.currentStepNumber();
                if(stateNumber == 1){
                    profilesService.createImport($stateParams.pickedApiSpaceId).then(function(data){
                        $scope.importId = data.id;
                        profilesService.uploadAndGetPreview($stateParams.pickedApiSpaceId, $scope.importId, $scope.newFile.data, fileType).then(function(previewResult){
                            newFileWatch();
                            delete $scope.newFile;
                            delete $scope.wrongFileError;
                            $scope.previewData = previewResult;
                            wizardHandler.next();
                            Object.keys(previewResult).forEach((key) => {
                                if(!key && !hasEmptyKey) {
                                    hasEmptyKey = true;
                                    growlService.danger("Empty column name in the file. Please add missing names.");
                                }
                            });
                        }).catch(function(error){
                            growlService.danger("Profiles preview wasn't prepared due to: " + error.statusText);
                        });
                    });
                }
                if(stateNumber == 2){
                    $scope.customMappings = Object.values($scope.custom);
                    $scope.customMappings = $scope.profileSchema.filter(function(schema){
                        return $scope.customMappings.includes(schema.path);
                    });
                    wizardHandler.next();
                }
                else if(stateNumber == 3){
                    var mapping = {};
                    for (var customName in $scope.custom) {
                        if ($scope.custom[customName]) {
                            mapping[customName] = $scope.custom[customName];
                            if($scope.config.matchField == $scope.custom[customName]){
                                $scope.config.oldMatchField = customName;
                            }
                        }
                    }
                    profilesService.checkDuplicates($stateParams.pickedApiSpaceId, $scope.importId, $scope.config.oldMatchField).then(function(result){
                        $scope.conflictsInData = result.duplicates;
                        wizardHandler.next();
                    }).catch(function(error){
                        growlService.danger("Profiles preview wasn't prepared due to: " + error.statusText);
                    });
                }
                else if(stateNumber == 4){
                    $scope.save().then(function(){
                        $scope.importStarted = true;
                    });
                }
            };
            $scope.profileSchema = [];
            $scope.conflicts = {};

            for (var i in profileSchema) {
                if (!profileSchema[i].onlyObjects && !profileSchema[i].path.startsWith('_') && !profileSchema[i].path.startsWith('facebook')) {
                    $scope.profileSchema.push(profileSchema[i]);
                }
            }
            
            $scope.state1Done = function(){
                var stateNumber  = WizardHandler.wizard("importWizard").currentStepNumber();
                return stateNumber >= 1 && $scope.fileValid;
            };
            $scope.state2Done = function(){
                var stateNumber  = WizardHandler.wizard("importWizard").currentStepNumber();
                return stateNumber >= 2 && Object.keys($scope.custom).length > 0 && !$scope.anyConflicts() && !hasEmptyKey;
            };
            $scope.state3Done = function(){
                var stateNumber  = WizardHandler.wizard("importWizard").currentStepNumber();
                return stateNumber >= 3 && $scope.config.matchField && !$scope.isIdColumn();
            };
            $scope.state4Done = function(){
                var stateNumber  = WizardHandler.wizard("importWizard").currentStepNumber();
                var codeRequired = $scope.isCodeRequired();
                return stateNumber >= 4 &&  (!codeRequired || (codeRequired && $scope.config.phoneNumberCountryCode));
            };

            $scope.isCodeRequired = function(){
                var phoneExist = false;
                var codeExist = false;
                for (var customName in $scope.custom) {
                    if($scope.custom[customName] == "phoneNumber"){
                        phoneExist = true;
                    }
                    if($scope.custom[customName] == "phoneNumberCountryCode"){
                        codeExist = true;
                    }
                }
                return phoneExist && !codeExist;
            };
            $scope.isIdColumn = function () {
                for (var customName in $scope.custom) {
                    if ($scope.custom[customName] && $scope.custom[customName].toLowerCase() == 'id' && $scope.config.matchField && $scope.config.matchField.toLowerCase() != 'id') return true;
                }
                return false;
            };
            $scope.customNameExist = function (header) {
                for (var customName in $scope.custom) {
                    if (customName != header && $scope.custom[customName]) {
                        if ($scope.custom[customName] && $scope.custom[header] && $scope.custom[customName].toLowerCase() == $scope.custom[header].toLowerCase()) {
                            $scope.conflicts[header] = true;
                            return;
                        }
                    }
                }
                $scope.conflicts[header] = false;
            };
            $scope.anyConflicts = function () {
                for (var i in $scope.conflicts) {
                    if ($scope.conflicts[i]) return true;
                }
                return false;
            };

            $scope.save = function () {
                var mapping = {};
                for (var customName in $scope.custom) {
                    if ($scope.custom[customName]) {
                        mapping[customName] = $scope.custom[customName];
                    }
                }
                return profilesService.startImport($stateParams.pickedApiSpaceId, $scope.importId, {
                    mapping: mapping,
                    matchBy: $scope.config.matchField,
                    ignoreDuplicates: !$scope.config.keep,
                    replaceExisting: $scope.config.overwrite,
                    phoneNumberCountryCode: $scope.config.phoneNumberCountryCode,
                    optInSettings: $scope.config.optInSettings
                }).then(function (result) {
                    growlService.success('Import processing. Please wait up to 15 minutes for this to be completed.', 0);
                    return result;
                }).catch(function (error) {
                    growlService.danger("Profiles weren't imported due to: " + error.statusText);
                });
            };

            $scope.ok = function(){
                $uibModalInstance.dismiss('cancel');
                $state.go("main.apiSpace.profiles.history");
            };

            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }]);

})(window.angular);